import React from "react";
import { REGISTRATION_OPENS_LABEL } from "../../config/event";

const UNITS = [
  { key: "days", label: "Dní" },
  { key: "hours", label: "Hodin" },
  { key: "minutes", label: "Minut" },
  { key: "seconds", label: "Sekund" },
];

const pad = (value) => String(value).padStart(2, "0");

/** Four-cell countdown. Screen readers get one static sentence instead of digits that change every second. */
const Countdown = ({ timeLeft }) => (
  <div className="countdown">
    <p className="sr-only">Registrace se otevře {REGISTRATION_OPENS_LABEL}.</p>
    <div className="countdown-cells" aria-hidden="true">
      {UNITS.map(({ key, label }) => (
        <div key={key} className="countdown-cell">
          <span className="countdown-value">{pad(timeLeft[key])}</span>
          <span className="countdown-label">{label}</span>
        </div>
      ))}
    </div>
  </div>
);

export default Countdown;
